import { TravellerJourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { getDescriptionText, useDescription } from './helpers';

const ACTION_TYPE = ACTION_TYPES.wait_for_attribute_change;

export const getDescription = (action: TravellerJourneyAction<typeof ACTION_TYPE>): string => {
  return getDescriptionText({ values: action.values, styled: false, translations: nodeLocale });
};

export const Node = (node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  const values = node.data?.values;
  const { descriptionText } = useDescription(values, nodeLocale);
  const description = node.data?.description?.trim();

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={description || descriptionText}
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    configureAction: 'Configure action',
    continueWhen: 'Continue when\n',
    continueWhenNoStyle: 'Continue when\n{field} {comparator} {value}',
    conditionDescription: '{field} {comparator} {value}',
    changesValue: 'changes',
  },
};
